import { Component, OnInit, inject } from '@angular/core';
import { TranslocoDirective, TranslocoService } from '@jsverse/transloco';
import { NgIf, CommonModule, KeyValue } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { AuthService } from '../providers/auth.service';
import { DbService } from '../providers/db.service';
import { SidebarService } from '../providers/sidebar.service';
import { environment } from './../../environments/environment';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { PaymentMethodsInterface, PeriodsInterface, PMInterface } from '../interfaces';



@Component({
  selector: 'app-user',
  standalone: true,
  imports: [TranslocoDirective, NgIf, FormsModule, CommonModule],
  templateUrl: './user.component.html',
  styleUrl: './user.component.css'
})
export class UserComponent implements OnInit {



  onSubmit(model, mode: string): void {
    if (mode === 'reg') {
      this.RegisterUser(model);
    }
    else if (mode === 'log') {
      this.LogInUser(model);
    }
    else if (mode === 'resetPassword') {
      this.resetForgottenPasswordAsync(model['email']);
    }

  }
  sortByValueAsc = <T>(a: KeyValue<string, T>, b: KeyValue<string, T>) => {
    return a.key.localeCompare(b.key);
  };

  getKeySuffix(key: unknown): string {
    return typeof key === 'string' ? key.substring(6) : '';
  }
  env = environment;
  sourcesSpinner = false;
  paymentMethodsDetails: string[] = [];
  userID: string | null | undefined = '123';
  errorMessage: string | null = null;
  closeResult!: string;
  currentJustify = 'justified';
  defaultPhoto = './../../assets/man.png';
  EditMode: string | null = null;
  ShowSpinner = true;
  showSpinner2 = true;
  LoginMode = true;
  RegisterMode = false;
  EmailHasError = true;
  PasswordHasError = false;
  usernameHasError = false;
  newUser = true;
  SignUpWarning = 'default';
  SignUpSuccess = false;
  SignInWarning = 'default';
  SignInSuccess = false;
  sideBarSize = '';
  ResetPasswordMode = false;
  CheckEmailMode = false;
  RegModel = {
    email: '',
    password: '',
    username: '',
    plan: '',
    terms: false,
    lang: ''
  };
  ResetPasswordModel = {
    email: ''
  };
  LogModel = {
    email: '',
    password: ''
  };

  UserDataModel = {
    name: '',
    surname: '',
    username: '',
    photoURL: '',
    uid: '',
    regDate: '',
    email: '',
    plan: '',
    lang: '',
    currency: ''
  };
  paymentMethodsModel = {
    name: ''
  };


  appVersion = '2.4.186';
  paymentMethods: PaymentMethodsInterface[] = [];
  langsArray = [{ full: 'Polski', id: 'pl' }, { full: 'English', id: 'en' }];
  currenciesArray = ['PLN', 'USD', 'EUR', 'GBP'];
  noCats = true;
  noTrans = true;
  noMeth = true;
  noName = false;
  param = { email: '@savologic.com', username: '', plan: '', lang: '' };
  progress = false;
  showSpinner = true;
  public db = inject(DbService);
  public auth = inject(AuthService);
  private translocoService = inject(TranslocoService);
  private toastr = inject(ToastrService);
  private router = inject(Router);
  public sb = inject(SidebarService);
  ngOnInit() {
    this.sideBarSize = this.sb.currentSidebarSize();
    this.showSpinner = false;
  }
  async sleep(ms: number): Promise<void> {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  async triggerSpinner(condition: boolean): Promise<void> {
    this.sourcesSpinner = condition;
    if (!condition) {
      console.log()
    } else {
      await this.sleep(1500);
      this.triggerSpinner(false);
    }
  }

  async updatePaymentMethods(method: string, source: string, action: string, userUID: string, value?: string) {
    try {
      await this.db.updatePaymentMethodsAsync(method, source, action, userUID, value);
      this.paymentMethodsModel = { name: '' };
      if (action === 'rename' && source === '0') {
        this.showToast('success', `${this.translocoService.translate('toasts.userSuccessMessageRenameMethod', undefined, this.auth.currentUserSig()?.lang)}`)
      }
      else if (action === 'rename' && (source === '1' || source === '2')) {
        this.showToast('success', `${this.translocoService.translate('toasts.userSuccessMessageRenameSource', undefined, this.auth.currentUserSig()?.lang)}`)
      }
      else if (action === 'delete' && (source === '1' || source === '2')) {
        this.showToast('success', `${this.translocoService.translate('toasts.userSuccessMessageDelSource', undefined, this.auth.currentUserSig()?.lang)}`)
      }
      else if (action === 'createSource') {
        this.showToast('success', `${this.translocoService.translate('toasts.userSuccessMessageAddSource', undefined, this.auth.currentUserSig()?.lang)}`)
      }
      else if (action === 'setDefault') {
        this.showToast('success', `${this.translocoService.translate('toasts.userSuccessMessageSetDefault', undefined, this.auth.currentUserSig()?.lang)}`)
      }
    } catch (err) {
      console.log(err.code)
      if (action === 'rename' && source === '0') {
        this.showToast('error', `${this.translocoService.translate('toasts.userFailMessageRenameMethod', undefined, this.auth.currentUserSig()?.lang)}`)
      }
      else if (action === 'rename' && (source === '1' || source === '2')) {
        this.showToast('error', `${this.translocoService.translate('toasts.userFailMessageRenameSource', undefined, this.auth.currentUserSig()?.lang)}`)
      }
      else if (action === 'delete' && (source === '1' || source === '2')) {
        this.showToast('error', `${this.translocoService.translate('toasts.userFailMessageDelSource', undefined, this.auth.currentUserSig()?.lang)}`)
      }
      else if (action === 'createSource') {
        this.showToast('error', `${this.translocoService.translate('toasts.userFailMessageAddSource', undefined, this.auth.currentUserSig()?.lang)}`)
      }
      else if (action === 'setDefault') {
        this.showToast('error', `${this.translocoService.translate('toasts.userFailMessageSetDefault', undefined, this.auth.currentUserSig()?.lang)}`)
      }
    }
  }

  async resetForgottenPasswordAsync(email: string): Promise<void> {
    try {
      await this.auth.ResetPasswordAsync(email);
      this.showToast('success', `${this.translocoService.translate('toasts.userAuth/reset-password', { email: email }, this.auth.currentUserSig()?.lang)}`)
      this.LoginMode = false;
      this.RegisterMode = false;
      this.ResetPasswordMode = false;
      this.CheckEmailMode = true;
    } catch (err) {
      const error = (err as Error).message
      this.showToast('error', `${this.translocoService.translate(error)}`)
    }
  }

  async LogInUser(model: { email: string; password: string; }): Promise<void> {
    this.progress = true;
    try {
      await this.auth.SignInWithEmailAsync(model.email, model.password);
      const userData = await this.db.getUserDocsAsync(this.auth.currentUserIDSig().uid);
      this.db.currentUserDataSig.set({
        currency: userData?.['currency'],
        email: userData?.['email'],
        lang: userData?.['lang'],
        name: userData?.['name'],
        newUser: userData?.['newUser'],
        username: userData?.['username'],
        plan: userData?.['plan'],
        regDate: userData?.['regDate'],
        surname: userData?.['surname'],
        transCounter: userData?.['transCounter'],
        uid: userData?.['uid']
      });
      const lang = this.auth.currentLangSig()?.lang ?? userData?.['lang'];
      if (lang) {
        this.auth.currentLangSig.set({
          lang: userData?.['lang']
        });
        this.translocoService.setActiveLang(lang);
      }
      const paymentMethods = await this.db.getPaymentMethodsAsync(this.auth.currentUserIDSig().uid) as PMInterface;
      this.db.currentPaymentMethodsSig.set(paymentMethods)
      const documents: PeriodsInterface[] = await this.db.getPeriodsAsync(this.auth.currentUserIDSig().uid)
      const currentDate = new Date().toISOString();
      const period: number = parseInt(currentDate.substring(0, 7).replace("-", ""))
      let check = 0;
      for (const item of documents) {
        if (item.content['periodID'] === period) {
          check = 1
        }
      }
      if (check > 0) {
        this.db.periodsSig.set(documents)
      } else {
        await this.db.addPeriodInPeriodsAsync(period, this.auth.currentUserIDSig().uid);
        const updatedDocuments = await this.db.getPeriodsAsync(this.auth.currentUserIDSig().uid)
        this.db.periodsSig.set(updatedDocuments)
      }
      model.email = '';
      model.password = '';
      await this.newPeriodCheck(this.auth.currentUserIDSig().uid)
      this.router.navigate(['/dashboard']);
    } catch (err) {
      if (err instanceof Error) {
        this.errorMessage = err.message;
      } else {
        this.errorMessage = String(err);
      }
      model.password = null;
    }
  }

  async RegisterUser(form: { email: string; username: string; plan: string; lang: string; password: string; }): Promise<void> {
    this.progress = true;
    let currency;
    this.param = { email: form.email, username: form.username, plan: form.plan, lang: form.lang };
    if (form.lang === 'pl') {
      currency = 'PLN';
    } else {
      currency = 'USD';
    }
    this.progress = false;
    try {
      await this.auth.RegisterWithEmail(form.email, form.password, form.username, form.lang);
      await this.db.CreateUserDocumentAfterRegistrationAsync(form, form.username, form.lang, currency, this.auth.currentUserIDSig().uid);
      const userData = await this.db.getUserDocsAsync(this.auth.currentUserSig().uid);
      this.db.currentUserDataSig.set({
        currency: userData?.['currency'],
        email: userData?.['email'],
        lang: userData?.['lang'],
        name: userData?.['name'],
        newUser: userData?.['newUser'],
        username: userData?.['username'],
        plan: userData?.['plan'],
        regDate: userData?.['regDate'],
        surname: userData?.['surname'],
        transCounter: userData?.['transCounter'],
        uid: userData?.['uid']
      })
      await this.db.createAllPaymentMethodsAsync(form.lang, this.auth.currentUserIDSig().uid);
    } catch (err) {
      console.log(err.code);
    }
  }

  async newPeriodCheck(userUID: string): Promise<void> {
    const currentPeriod = parseInt(new Date().toISOString().substring(0, 10).substring(0, 7).replace("-", ""));
    try {
      const allPeriods = await this.db.getPeriodsAsync(userUID);
      let i = 0;
      for (const period of allPeriods) {
        if (period.content['periodID'] === currentPeriod) {
          i++;
        }
      }
      if (i === 0) {
        await this.db.addPeriodInPeriodsAsync(currentPeriod, userUID)
        console.log('qwe123, exeuted')
      }
      await this.db.getPeriodsAsync(userUID)
      const cats = await this.db.getCatsAsync(userUID)
      let j = 0;
      for (const category of cats) {
        for (const key of Object.keys(category.content)) {
          if (parseInt(key) === currentPeriod) {
            j++;
          }
        }
      }
      if (j != cats.length) {
        for (const category of cats) {
          await this.db.createNewPeriodInCategoriesAsync(currentPeriod, category['id'], userUID)
        }
      }

    } catch (err) {
      console.log(err.code)
    }
  }


  editUserData(box?: string) {
    if (!box) {
      this.EditMode = null;
    } else {
      this.EditMode = box;
    }
  }

  toggleMode() {
    this.EditMode = 'false';
  }
  async updateAccountDetails(fullModel: { lang: string; name: string; surname: string; }) {
    try {
      this.UserNameCheck(fullModel);
      await this.db.updateUserDataAsync(fullModel, this.auth.currentUserIDSig().uid)
      this.showToast('success', `${this.translocoService.translate('toasts.userSuccessMessageUpdateDetails', undefined, this.auth.currentUserSig()?.lang)}`)
      if (fullModel.lang) {
        this.translocoService.setActiveLang(fullModel.lang);
        this.auth.currentLangSig.set({ lang: fullModel.lang });
        sessionStorage.setItem('userLanguage', fullModel.lang);
        this.EditMode = 'false';
      }
    } catch (err) {
      console.log(err.code)
      this.showToast('error', `${this.translocoService.translate('toasts.userFailMessageUpdateDetails', undefined, this.auth.currentUserSig()?.lang)}`)
      this.EditMode = 'false';
    }
  }
  UserNameCheck(user: { name: string; surname: string; }) {
    if ((user.name + user.surname) === 'JohnSmith') {
      this.noName = true;
    }
  }
  valuesPasser(method: string, source: string, value: string) {
    this.paymentMethodsDetails = [];
    this.paymentMethodsDetails.push(method, source, value)
  }
  showToast(toastType: string, title: string, content?: string) {
    const varTimeOut = 4000;
    const varProgressBar = true;
    const varPositionClass = 'toast-top-center';
    if (toastType === 'success') {
      this.toastr.success(content, title, {
        timeOut: varTimeOut,
        progressBar: varProgressBar,
        positionClass: varPositionClass
      });
    } else if (toastType === 'info') {
      this.toastr.info(content, title, {
        timeOut: varTimeOut,
        progressBar: varProgressBar,
        positionClass: varPositionClass
      });
    } else {
      this.toastr.error(content, title, {
        timeOut: varTimeOut,
        progressBar: varProgressBar,
        positionClass: varPositionClass
      });
    }
  }

  async runFillMissingHashes() {
    try {
      const auth = await this.auth.getGetAuth();
      const user = auth.currentUser;

      if (!user) {
        alert("Musisz być zalogowany.");
        return;
      }

      const token = await user.getIdToken();

      const response = await fetch(environment.functions.fillMissingHashes, {
        method: "POST",
        headers: {
          "Authorization": `Bearer ${token}`
        }
      });


      const text = await response.text();
      alert("Wynik: " + text);

    } catch (err) {
      console.error(err);
    }
  }
  
  async runFixAmounts() {
    try {
      const auth = await this.auth.getGetAuth();
      const user = auth.currentUser;

      if (!user) {
        alert("Musisz być zalogowany.");
        return;
      }

      const token = await user.getIdToken();

      const response = await fetch(environment.functions.fixAmounts, {
        method: "POST",
        headers: {
          "Authorization": `Bearer ${token}`
        }
      });


      const text = await response.text();
      alert("Wynik: " + text);

    } catch (err) {
      console.error(err);
    }
  }

}